export const selectAllAuthorizations = state => state.authorization.authorizations
export const selectActiveAuth = state => state.authorization.active
export const selectUrlOauth = state => state.authorization.oauthUrl
export const companyExistInGoogleOauth = state => state.authorization.oauthUrl === "Exist"

